import { Component, Input, OnInit } from '@angular/core';
import { ChartFactory } from '@ddt-web/chart';
import { TabData } from '@ddt-web/data-service';
import * as get from 'lodash/get';

import { TooltipOffset } from '../model/style-box.interface';

@Component({
	selector: 'ac-style-box-tooltip',
	templateUrl: './style-box-tooltip.component.html',
	styleUrls: ['./style-box-tooltip.component.scss']
})
export class StyleBoxTooltipComponent implements OnInit {
	@Input() public data: TabData;
	@Input() public parentData: TabData;
	@Input() public customTooltipOffset?: TooltipOffset;
	@Input() public productNameCharacterLimit?: number;
	@Input() public tooltipWidth?: number = 190;

	public positionLeft: number = 0;
	public positionTop: number = 0;

	private TOOLTIP_OFFSET_Y = 120;
	private TOOLTIP_OFFSET_X = 20;

	public isVisible: boolean = false;
	private currentSelectedStyleBoxIndex: number;
	private currentSelectedPortfolioIndex: number;
	public tooltipHtml: string;

	public ngOnInit(): void {
		this.TOOLTIP_OFFSET_Y = this.customTooltipOffset?.y || this.TOOLTIP_OFFSET_Y;
		this.TOOLTIP_OFFSET_X = this.customTooltipOffset?.x || this.TOOLTIP_OFFSET_X;
	}

	public onMouseEvent(event: MouseEvent, selectedPortfolioIndex: number): void {
		const target: any = event.target;
		const isStyleBoxPointMouseOver = target.tagName === 'path' || target.tagName === 'text' && !isNaN(target.innerHTML);
		if (isStyleBoxPointMouseOver && event.type !== 'mouseleave') {
			const styleBoxIndex = this.findHoverIndex(target);
			if (this.currentSelectedStyleBoxIndex !== styleBoxIndex || this.currentSelectedPortfolioIndex !== selectedPortfolioIndex) {
				this.currentSelectedStyleBoxIndex = styleBoxIndex;
				this.currentSelectedPortfolioIndex = selectedPortfolioIndex;
				this.updateToolTip();
			}
			this.isVisible = true;
			this.onMouseMove(event);
		} else {
			this.isVisible = false;
		}
	}

	public findHoverIndex(target: any): number {
		return target.tagName === 'path' ?
			Array.prototype.indexOf.call(target.parentNode.childNodes, target) :
			Array.prototype.indexOf.call(target.parentNode.parentNode.childNodes, target.parentNode) - 2;
	}

	public onMouseMove(event: MouseEvent): void {
		this.positionTop = event.clientY - this.TOOLTIP_OFFSET_Y;
		this.positionLeft = this.getLeftPosition(event);
	}

	private getLeftPosition(event: MouseEvent): any {
		let newPosition = event.clientX + this.TOOLTIP_OFFSET_X;
		const exceedsBoundLeft = event.clientX - this.tooltipWidth / 2 < 0;
		const exceedsBoundRight = event.clientX + this.tooltipWidth > window.innerWidth;
		if (exceedsBoundLeft) {
			newPosition = event.clientX + this.TOOLTIP_OFFSET_X;
		}

		if (exceedsBoundRight) {
			newPosition = event.clientX - (this.tooltipWidth + this.TOOLTIP_OFFSET_X);
		}

		return newPosition;
	}

	public updateToolTip(): void {
		const originalStyleIndex = Math.floor(this.currentSelectedStyleBoxIndex / 3) * 4 + (this.currentSelectedStyleBoxIndex % 3) + 1;
		this.tooltipHtml = ChartFactory.getContributionTooltip(
			this.data,
			this.currentSelectedStyleBoxIndex,
			this.currentSelectedPortfolioIndex,
			get(this.parentData, `tableData[0].cells[${originalStyleIndex}][${this.currentSelectedPortfolioIndex}]`),
			get(this.data, `tableData[0].headersY`),
			this.productNameCharacterLimit
		);
	}
}
